export default __webpack_public_path__ + "static/media/leader_notes.3c68cf49.pdf";